import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Hero from './components/Hero';
import Services from './components/Services';
import Portfolio from './components/Portfolio';
import UnitDetails from './components/UnitDetails';
import Legal from './components/Legal';
import Nearby from './components/Nearby';
import About from './components/About';
import NotFound from './components/NotFound';
import './App.css';

const pageTitles = {
  '/': '7601 Canada Avenue | Orlando Vacation Suites',
  '/310': 'Nature Green Suite 310 | Orlando Stay',
  '/414': 'Royal Blue Suite 414 | Orlando Stay',
  '/612': 'Cozy Grey Suite 612 | Orlando Stay',
  '/amenities': '7601 Canada Avenue | Resort Amenities',
  '/nearby': '7601 Canada Avenue | Explore Orlando',
  '/about': 'About 7601 Canada | Orlando Suite Stays',
  '/privacy': '7601 Canada Avenue | Privacy Policy',
  '/terms': '7601 Canada Avenue | Terms of Service',
  '/accessibility-statement': '7601 Canada | Accessibility Statement'
};

const PageTitle = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = pageTitles[pathname] || '7601 Canada Avenue | Orlando Suites';
  }, [pathname]);

  return null;
};

function App() {
  return (
    <Router>
      <PageTitle />
      <ScrollToTop />
      <div className="min-h-screen bg-white selection:bg-accent-orange selection:text-white">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={
              <>
                <Hero />
                <Services />
              </>
            } />
            <Route path="/310" element={<UnitDetails />} />
            <Route path="/414" element={<UnitDetails />} />
            <Route path="/612" element={<UnitDetails />} />
            <Route path="/amenities" element={<Portfolio />} />
            <Route path="/nearby" element={<Nearby />} />
            <Route path="/about" element={<About />} />
            <Route path="/legal" element={<Legal />} />
            <Route path="/privacy" element={<Legal />} />
            <Route path="/terms" element={<Legal />} />
            <Route path="/accessibility-statement" element={<Legal />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;